import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { PublicationWageType } from './publication-wage-type.interface';

export class PublicationWageTypeService {
   async getPublicationWageTypes(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<PublicationWageType>>>(`/publication-wage-types`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async getPublicationWageType() {
      throw Error('Method not implemented');
   }

   async postPublicationWageType() {
      throw Error('Method not implemented');
   }

   async putPublicationWageType() {
      throw Error('Method not implemented');
   }

   async deletePublicationWageType() {
      throw Error('Method not implemented');
   }
}
